import React, { Component, Fragment } from 'react'
import { AppletsDeleteModel } from './models/applets.delete.model'
import { DeleteResponseModel } from '../../../../../shared/models'
import { AppletsService } from '../applets/services/applets.services'
import { HttpResponse } from '../../../../../core';
import { ShowSuccessMessage, HandleNotFoundResponse } from '../../../../../shared/helpers';
import { NavLink } from "react-router-dom";
import { AppletsTabs } from './AppletsTabs';
import { ButtonType } from '../../../../../shared/enums/button.enum';
import { NotFoundResponseArea } from '../../../../../shared/enums';

interface IState {
    result?: AppletsDeleteModel;
    deleteResult?: DeleteResponseModel;
    isDoubleleClick?: boolean;
}
export class AppletsDelete extends Component<any, IState> {
    private service: AppletsService;
    constructor(props) {
        super(props);
        this.state = this.initialState;
        this.service = new AppletsService();
        this.deleteRecord = this.deleteRecord.bind(this);
    }

    initialState: Partial<IState> = {
        result: {
            id: 0,
            name: "",
            report: {
                text: "",
                value: 0
            }
        },
        deleteResult: { isdeleted: false },
        isDoubleleClick: false
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {       
            this.service.getLinkedResourcesById(this.props.match.params.id)
                .then((res: HttpResponse<AppletsDeleteModel>) => {
                    if (res && res.result) {
                        this.setState({
                            result: res.result
                        });
                    }
                })
                .catch(ex => {
                    HandleNotFoundResponse(ex,NotFoundResponseArea.Applets,this.props) 
                });        
    }

    deleteRecord() {
        if (!this.state.isDoubleleClick) {
            this.setState({ isDoubleleClick: true })
        this.service.deleteRecordById(this.props.match.params.id)
            .then((res: HttpResponse<DeleteResponseModel>) => {
                if (res && res.result) {
                    this.setState({
                        deleteResult: res.result
                    }, () => {
                        if (this.state.deleteResult?.isdeleted) {
                            ShowSuccessMessage("Applet successfully deleted.");
                            this.props.history.push('/applet/list');
                        }
                    });
                }
            });
        }
    }
    render() {
        return (
            <Fragment>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5>Delete Applet '{this.state.result?.name}'</h5>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <AppletsTabs id={this.props.match.params.id} url="/applet/delete/" />
                                <div className="alert font-weight-bold  alert-light"> <i className="fas fa-exclamation-circle text1"></i> Are you sure you want delete this Applet  <strong>“{this.state.result?.name}”</strong> ?</div>

                                <p className="mt-4 text-danger"><i className="fas fa-exclamation-triangle text1"></i> The following related items may be deleted or orphaned:</p>
                                <div className="row ">
                                    <div className="col">
                                        <div className="card card-primary shadow-sm">
                                            <div className="card-header">
                                                <h4>Applet</h4>
                                            </div>
                                            <div className="card-body">
                                                <NavLink className="badge badge-light" to={"/applet/detail/" + this.state.result?.id}>{this.state.result?.name}</NavLink>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="card card-danger shadow-sm">
                                            <div className="card-header">
                                                <h4>Report </h4>
                                            </div>
                                            <div className="card-body">
                                                {this.state.result?.report && <NavLink className="badge badge-light" to={"/report/detail/" + this.state.result?.report.value}>{this.state.result?.report.text}</NavLink>}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row mb-4">
                            <div className="mx-auto">
                                <button  disabled={this.state.isDoubleleClick} className="btn btn-lg btn-danger" onClick={this.deleteRecord}> {ButtonType.Delete}</button>
                                <NavLink type="button" className="btn btn-lg btn-default ml-3" to="/applet/list">{ButtonType.Cancel}</NavLink>
                            </div>
                        </div>
                    </div>

                </div>
            </Fragment>
        )
    }
}
